import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class NavigationTrackerService {
    private previousUrl: string;
    private currentUrl: string;

    private history = [];
  

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
        this.add(event.urlAfterRedirects);
      }
    });
  }

    public getPreviousUrl(): string {
        return this.previousUrl;
    }
  
    add(url) {
        this.history.push(url);
        if (this.history.length > 100) {
            this.history.shift(); 
        }
    }

    getItems() {
        return this.history;
    }

    public getPreviousCiListSearch(): string{
        const regex = /^\/search$|^\/projects\/[A-Za-z0-9-]+\/items(?:\?.*)?$/i;


        for (let i = this.history.length - 1; i >= 0; i--) {
            if (regex.test(this.history[i])) {
            return this.history[i];
            }
        }

        return "/";
    }

    /**
     * Keep the last list/search history entry in sync when filters are applied via
     * Location.replaceState (no NavigationEnd). Otherwise Cancel from CI detail
     * returns to a stale list URL without Filter by Status (STG parity).
     */
    public rememberCiListSearch(url: string): void {
        if (!url) {
            return;
        }
        const normalized = url.startsWith('#') ? url.substring(1) : url;
        const regex = /^\/search(?:\?.*)?$|^\/projects\/[A-Za-z0-9-]+\/items(?:\?.*)?$/i;
        if (!regex.test(normalized)) {
            return;
        }
        for (let i = this.history.length - 1; i >= 0; i--) {
            if (regex.test(this.history[i])) {
                this.history[i] = normalized;
                return;
            }
        }
        this.history.push(normalized);
    }
}
